// src/composables/useLocation.js
export function useLocation() {
  function getUserLocation(timeout = 5000) {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation not supported"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          reject(error);
        },
        {
          enableHighAccuracy: false,
          timeout,
          maximumAge: 0
        }
      );
    });
  }

  return { getUserLocation };
}
